var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuth)?_c('div',{staticClass:"c-brands-slug-ad-list",on:{"scroll":_vm.onScroll}},[(_vm.init)?_c('AdList',{ref:"multi",attrs:{"adIds":_vm.adIds},on:{"onSave":_vm.onSave}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }